export default [
	{  // 商品推荐
		path: 'recommended_list',
		name: 'm_recommended',
		component: () => import('@/pages/operation/recommended_list')
	}, {  // 商品推荐新增页
		path: 'recommended_add',
		name: 'recommended_add',
		meta: {
			title: '新增策略'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/recommended_add')
	}, {  // 商品推荐编辑页
		path: 'recommended_edit/:id',
		name: 'recommended_edit',
		meta: {
			title: '编辑策略'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/recommended_edit')
	}, {  // 热门关键字
		path: 'popular_key_words',
		name: 'm_product_popular_key_words',
		component: () => import('@/pages/operation/popular_key_words')
	}, {  // 常见问题
		path: 'problem_list',
		name: 'm_problem',
		component: () => import('@/pages/operation/problem_list')
	},{  // 文摘咨询
		path: 'abstract_consultation',
		name: 'm_abstract_consultation',
		component: () => import('@/pages/operation/abstract_consultation')
	}, {  // 文摘咨询新增页
		path: 'abstract_consultation_add',
		name: 'abstract_consultation_add',
		meta: {
			title: '新增资讯'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/abstract_consultation_add')
	}, {  // 文摘咨询编辑页
		path: 'abstract_consultation_edit/:id',
		name: 'abstract_consultation_edit',
		meta: {
			title: '编辑资讯'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/abstract_consultation_edit')
	}, {  // 文摘咨询详情页
		path: 'abstract_consultation_detail/:id',
		name: 'abstract_consultation_detail',
		meta: {
			title: '资讯详情'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/abstract_consultation_detail')
	},{  // 商家操作指南
		path: 'stationed_operation_guide',
		name: 'm_stationed_operation_guide',
		component: () => import('@/pages/operation/stationed_operation_guide')
	}, {  // 商家操作指南新增页
		path: 'stationed_operation_guide_add',
		name: 'stationed_operation_guide_add',
		meta: {
			title: '新增指南'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/stationed_operation_guide_add')
	}, {  // 商家操作指南编辑页
		path: 'stationed_operation_guide_edit/:id',
		name: 'stationed_operation_guide_edit',
		meta: {
			title: '编辑指南'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/stationed_operation_guide_edit')
	}, {  // 文摘咨询详情页
		path: 'stationed_operation_guide_detail/:id',
		name: 'stationed_operation_guide_detail',
		meta: {
			title: '操作指南详情'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/abstract_consultation_detail')
	},{  // 平台规则
		path: 'platform_rule',
		name: 'm_platform_rule',
		component: () => import('@/pages/operation/platform_rule')
	}, {  // 平台规则新增页
		path: 'platform_rule_add',
		name: 'platform_rule_add',
		meta: {
			title: '新增平台规则'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/platform_rule_add')
	}, {  // 平台规则编辑页
		path: 'platform_rule_edit/:id',
		name: 'platform_rule_edit',
		meta: {
			title: '编辑平台规则'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/platform_rule_edit')
	}, {  // 文摘咨询详情页
		path: 'platform_rule_detail/:id',
		name: 'platform_rule_detail',
		meta: {
			title: '平台规则详情'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/abstract_consultation_detail')
	},{  // 常见问题
		path: 'faq',
		name: 'm_faq',
		component: () => import('@/pages/operation/faq')
	},{  // 通知公告
		path: 'platform_notice',
		name: 'm_platform_notice',
		component: () => import('@/pages/operation/platform_notice')
	}, {  // 通知公告新增页
		path: 'platform_notice_add',
		name: 'platform_notice_add',
		meta: {
			title: '新增通知公告'
		},
		props: route => route.query,
		component: () => import('@/pages/operation/platform_notice_add')
	}, {  // 通知公告编辑页
		path: 'platform_notice_edit/:id',
		name: 'platform_notice_edit',
		meta: {
			title: '编辑通知公告'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/platform_notice_edit')
	}, {  // 文摘咨询详情页
		path: 'platform_notice_detail/:id',
		name: 'platform_notice_detail',
		meta: {
			title: '通知公告详情'
		},
		props: route => route.params,
		component: () => import('@/pages/operation/platform_notice_detail')
	},
];